import PropTypes from 'prop-types'
import React, { useCallback, useRef, useState } from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import { localize } from '../../utils/TranslationUtils'
import routes from '../../router/routes'
import NavbarLink from '../Navbar/NavbarLink'

import MenuLink from './MenuLink'
import styles from './styles'
import Link from '../Link'
import ImageStatic from '../ImageStatic'
import { useMousePosition } from '../../hooks'
import MenuImage from './MenuImage'
import { navigate } from 'gatsby'

const decorators = [
  localize,
  memoized,
]

function Menu(props) {
  const { routesInfos, otherRoutesInfos, enableTab, onTouchEnd, onClose, t, locale, locales } = props


  const domainRoutes = routesInfos
  const otherRoutes = otherRoutesInfos

  const mousePosition = useMousePosition()
  const [imageActiveIndex, setImageActiveIndex] = useState(-1)

  const mouseEnterHandler = useCallback((index) => {
    setImageActiveIndex(index)
  }, [])

  const mouseLeaveHandler = useCallback(() => {
    setImageActiveIndex(-1)
  }, [])


  return (
    <>
      <div className="top-nav">
        <div
          onClick={() => {
            navigate(`/${locale}`)
            onClose()
          }}
        >
          <ImageStatic
            className="logo"
            width={40}
            height={30}
            src="/images/logos/logo-white.svg"
          />
        </div>
        <button
            className='back-button'
            tabIndex={enableTab ? 0 : -1}
            onClick={onClose}
            onTouchEnd={onClose}
            role="button"
            aria-label={'back-button'}
          >
            <span className="label">{t('closeLabel').toUpperCase()}</span>
          </button>
      </div>
      <ul
        role={'menubar'}
        className="container"
      >
        {domainRoutes.map((routeInfo, index) => (
          <MenuLink
            key={routeInfo.name}
            enableTab={enableTab}
            onTouchEnd={onTouchEnd}
            route={routeInfo.route}
            routeParams={routeInfo.routeParams}
            link={routeInfo.link}
            label={routeInfo.name}
            selected={routeInfo.active}
            target={routeInfo.route ? '_self' : '_blank'}
            onMouseEnter={() => mouseEnterHandler(index)}
            onMouseLeave={() => mouseLeaveHandler()}
          />
        ))}
      </ul>

      <div className="links-media">
        {domainRoutes.map(({ image }, index) => <MenuImage key={index} image={image.fluid} isActive={index === imageActiveIndex} x={mousePosition.x} y={mousePosition.y} />)}
      </div>

      <div className="bottom-nav">
        <ul className="lang-block" role={'menubar'}>
          {locales.map(lang => (
            <NavbarLink
              key={lang.code}
              enableTab={enableTab}
              onTouchEnd={onTouchEnd}
              route={routes.home.path}
              selected={lang.code === locale}
              routeParams={{ locale: lang.code }}
              label={t(`version_${lang.code}`)}
            />
          ))
        }
        </ul>

        <ul className="other-items-block" role={'menubar'}>
          {otherRoutes.map(routeInfo => (
            <MenuLink
              key={routeInfo.name}
              enableTab={enableTab}
              onTouchEnd={onTouchEnd}
              route={routeInfo.route}
              routeParams={routeInfo.routeParams}
              link={routeInfo.link}
              label={routeInfo.name}
              selected={routeInfo.active}
              target={routeInfo.route ? '_self' : '_blank'}
            />
          ))
        }
        </ul>
      </div>
      <style jsx>{styles}</style>
    </>
  )
}

Menu.propTypes = {
  routesInfos: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      route: PropTypes.string,
      link: PropTypes.string,
      active: PropTypes.boolean,
      routeParams: PropTypes.shape({}),
    })
  ).isRequired,
  enableTab: PropTypes.bool.isRequired,
  onTouchEnd: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func,
  locale: PropTypes.string.isRequired,
  locales: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
  })),
}

Menu.defaultProps = {
  locales: [],
  t: () => null,
}

Menu = chainDecorators(decorators, Menu)

export default Menu
